























import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { upload } from '@/common/util/ossUploadService';

@Component({
    components: {},
})
export default class ImageNumUpload extends Vue {
    @Prop()
    public data;
    @Prop()
    public num: number;

    setValue(value) {
        this.allSrc = value;
    }
    async mounted() {}
    @Watch('data')
    public dataChange() {
        this.allSrc = this.data;
    }
    public $refs: {
        imageUploadInput: HTMLFormElement;
    };
    // public isShow = false;
    public file;
    public src;
    public allSrc: any[] = [];
    public imgName = '';
    public async changeFile(e) {
        if (e.target.files.length > 1) {
            if (this.allSrc.length + e.target.files.length > 6) {
                this.$message.error('最多只能上传6张');
                return;
            }
            e.target.files.forEach(async (ele) => {
                console.log(ele);
                this.imgName = ele.name;
                let imgType = this.imgName.split('.').pop();
                let allowType = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];
                this.file = ele;
                this.src = URL.createObjectURL(ele);
                if (allowType.indexOf(imgType.toLowerCase()) === -1) {
                    this.$alert('不支持该文件类型').then((e) => {
                        this.src = null;
                        this.$refs.imageUploadInput.value = null;
                    });
                    return;
                }
                if (ele.size > 1 * 1024 * 1024) {
                    this.$alert('该文件已超出指定大小').then((e) => {
                        this.src = null;
                        this.$refs.imageUploadInput.value = null;
                    });
                    return;
                }
                await this.upload();
            });
        } else {
            if (e.target.files[0]) {
                this.imgName = e.target.files[0].name;
                let imgType = this.imgName.split('.').pop();
                let allowType = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];
                this.file = e.target.files[0];
                this.src = URL.createObjectURL(e.target.files[0]);
                if (allowType.indexOf(imgType.toLowerCase()) === -1) {
                    this.$alert('不支持该文件类型').then((e) => {
                        this.src = null;
                        this.$refs.imageUploadInput.value = null;
                    });
                    return;
                }
                if (e.target.files[0].size > 1 * 1024 * 1024) {
                    this.$alert('该文件已超出指定大小').then((e) => {
                        this.src = null;
                        this.$refs.imageUploadInput.value = null;
                    });
                    return;
                }
                this.upload();
            }
        }

        e.target.value = '';
    }

    public deleteSrc(i) {
        this.src = null;
        this.allSrc.splice(i, 1);
        // this.isShow = false;
        this.$emit('setAllImage', this.allSrc);
    }

    public async upload() {
        const res = await upload(this.file, this.imgName);
        if (res.res.statusCode == '200') {
            let url = res.res.requestUrls[0].split('?')[0];
            this.allSrc.push(url);
            // this.allSrc.push({
            //     path: url,
            //     name: this.imgName,
            // });
            this.$emit('setAllImage', this.allSrc);
        } else {
            this.$message.warning('图片上传失败!');
        }
    }
}
